import { useCallback, useEffect } from 'react';
import { useLoadDataRequest } from '@futrli/shared-services';
import { generateForecastTemplate } from '../../../core/api/forecast';

type RequestDataType = Awaited<ReturnType<typeof generateForecastTemplate>>;

/**
 * Loads the chart of accounts for the given forecast ID
 * @param workspaceId - Workspace ID for the organisation
 * @param organisationId - Organisation ID
 * @param forecastKind - Forecast kind to generate the template for
 * @param forecastFrom - The date to generate the forecast from (DD/MM/YYYY)
 */
export const useGenerateExcelForecastTemplate = (
  workspaceId?: string,
  organisationId?: string,
  forecastKind?: 'budget' | 'scenario',
  forecastFrom?: string
) => {
  const hasAllParams = !!workspaceId && !!organisationId && !!forecastKind && !!forecastFrom;
  const { load, ...rest } = useLoadDataRequest<RequestDataType>();

  const reload = useCallback(async () => {
    if (hasAllParams) {
      load(
        generateForecastTemplate(workspaceId, organisationId, {
          forecast_from_date: forecastFrom,
          forecast_kind: forecastKind
        })
      );
    }
  }, [forecastFrom, forecastKind, hasAllParams, load, organisationId, workspaceId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    hasAllParams,
    reload,
    ...rest
  };
};
